<div class="site-footer">
    <img 
        src="/assets/img/logo-1.png" 
        alt="INDIGITAL"
    >
    <!--<p class="site-footer__text">
        INDIGITAL {{ anio }} &copy; Todos los derechos reservados. V1.0.1
    </p>-->

    <p class="site-footer__text">
        &copy;Todos los derechos reservados. V.3
    </p>
</div>
